(function () {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$rootScopeProvider'];

    /**
     * Created by vimpans on 2019/8/20
     */

    function stateConfig($stateProvider) {
        $stateProvider
            .state('preview', {
                parent: 'module',
                url: '/preview',
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/module/preview/preview.html',
                        controller: 'PreviewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
    }
})();
